import Swiper from '../../../../node_modules/swiper/swiper-bundle.mjs';

export const initBrandsSlider = function() {
  const sliderBrands = document.querySelector('[data-slider-brands="slider"]');
  if (!sliderBrands) {
    return;
  }

  const swiperBrands = function() {
    new Swiper(sliderBrands, {
        spaceBetween: 25,

        // slidesOffsetBefore: 22,
        slidesPerView: 3,
        slidesPerGroup: 3,
        pagination: {
          el: '[data-slider-brands="pagination"]',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: '[data-slider-brands="arrow-next"]',
          prevEl: '[data-slider-brands="arrow-prev"]'
        },
        breakpoints: {
          768: {
            // slidesOffsetAfter: 50,
            spaceBetween: 20,
            slidesPerGroup: 1,
            // slidesPerView: 6.9
            slidesPerView: 7
          },
          1200: {
            // slidesOffsetBefore: 60,
            slidesPerView: 7
            // slidesPerView: 7.3
          }
        }
      }
    );
  }
  swiperBrands();
};
